import { Button, Dialog, Grid, TextField, Typography, useTheme, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import AddIcon from '@mui/icons-material/Add';
import { SuppliesMainGroupName } from "../../../../models/suppliesMain";
import { useFormDivisionController } from "../../controller/components/division";
import { SuppliesDivisionModel } from "../../../../models/suppliesDivisionModel";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import { useTranslation } from "react-i18next";

interface Props {
    onOpen: boolean,
    onClose: VoidFunction
    mainId: SuppliesMainGroupName[]
    selectedDiv: SuppliesDivisionModel
    onfetch: VoidFunction
    selected: Function
}

const FormDivisionView = ({ onOpen, onClose, mainId, selectedDiv, onfetch, selected }: Props) => {
    const controllers = useFormDivisionController({ mainId, selectedDiv, onOpen, onClose, onfetch, selected });
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const { t } = useTranslation('global');


    return <Dialog
        fullWidth
        maxWidth={'lg'}
        open={true}
        sx={{ display: onOpen ? "block" : "none" }}
    >
        <Box sx={{ p: isSmallScreen ? 2 : 6 }}>
            <form onSubmit={(e) => controllers.handleOpenForm(e)}>
                <Box mb={isSmallScreen ? 1 : 2}>
                    <Typography variant="h4">{selectedDiv ? t("masterCategory_page.Update Division") : t("masterCategory_page.Create Division")}</Typography>
                </Box>
                <Grid container spacing={isSmallScreen ? 1 : 2}>
                    <Grid item xs={12} sm={6}>
                        <Box sx={{
                            p: isSmallScreen ? 2 : 4, boxShadow:
                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                        }}>
                            <Box sx={{ width: '100%', mt: isSmallScreen ? 1 : 2 }}>
                                <Box>
                                    <Typography>{t("masterCategory_page.Division Code")}</Typography>
                                    <TextField fullWidth inputRef={controllers.divCode} required size="small" margin="normal" />
                                </Box>
                            </Box>
                            <Box sx={{ width: '100%', mt: isSmallScreen ? 1 : 2 }}>
                                <Box>
                                    <Typography>{t("masterCategory_page.Name la")}</Typography>
                                    <TextField fullWidth inputRef={controllers.nameLa} required size="small" margin="normal" />
                                </Box>
                            </Box>
                            <Box sx={{ width: '100%', mt: isSmallScreen ? 1 : 2 }}>
                                <Box>
                                    <Typography>{t("masterCategory_page.Name en")}</Typography>
                                    <TextField fullWidth inputRef={controllers.nameEn} required size="small" margin="normal" />
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={isSmallScreen ? 12 : 6}>
                        <Box mt={isSmallScreen ? 1 : 2} sx={{
                            boxShadow:
                                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                            width: '100%',
                            height: '80%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#F4F6F8',
                        }}>
                            <Box >
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                                    <label htmlFor="image-input-division">
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#EBEBEB', width: isSmallScreen ? 100 : 150, height: isSmallScreen ? 100 : 150, borderRadius: "10px", cursor: 'pointer' }}>
                                            {
                                                controllers.imageToShow ? <img src={controllers.imageToShow} style={{ width: isSmallScreen ? 100 : 200, height: isSmallScreen ? 100 : 200, borderRadius: '10px' }} alt='' /> :
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <AddIcon />
                                                        <Typography>{t("masterCategory_page.Add Image")}</Typography>
                                                    </Box>
                                            }
                                        </Box>
                                    </label>
                                    <input
                                        type="file"
                                        id="image-input-division"
                                        onClick={(e: any) => {
                                            e.target.value = '';
                                        }}
                                        onChange={controllers.handleSelectImage}
                                        style={{ display: 'none' }}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <Box mt={isSmallScreen ? 1 : 2}>
                    {controllers.imageError && <Typography color='error'>{controllers.imageError}</Typography>}
                    {controllers.errorMessage && <Typography color='error'>{controllers.errorMessage}</Typography>}
                </Box>
                <Box mt={isSmallScreen ? 4 : 2} sx={{ display: 'flex', justifyContent: isSmallScreen ? 'center' : 'end' }}>
                    <Button onClick={() => { onClose(); controllers.handleReset() }} variant="outlined" color='error' sx={{ textTransform: 'none', width: 150 }}>
                        {t("masterCategory_page.Cancel")}
                    </Button>
                    <Button type="submit" variant="contained" color="secondary" sx={{ textTransform: 'none', color: '#fff', ml: isSmallScreen ? 1 : 2, width: 180 }}>
                        {selectedDiv ? t("masterCategory_page.Update Division") : t("masterCategory_page.Create Division")}
                    </Button>
                </Box>
                <ConfirmDialog
                    open={controllers.openConfirmForm}
                    title={selectedDiv ? t("masterCategory_page.Do you want to update this division ?") : t("masterCategory_page.Do you want to create this division ?")}
                    loading={controllers.loadingConfirmButton}
                    onCancel={controllers.handleCloseConfirmForm}
                    onConfirm={() => controllers.handleSubmit()}
                />
            </form>
        </Box>
    </Dialog>
}
export default FormDivisionView;